// eslint-disable-next-line no-shadow
export enum ErrorTypes {
  RequestError = 'RequestError',
  GenericError = 'GenericError',
  ValidationError = 'ValidationError',
  EmailAddressInUse = 'EmailAddressInUse',
}
